import { nxtPresent } from './nxtPresent';
import { nxtDialer } from './nxtDialer';
import { nxtHeadsetSlash } from './nxtHeadsetSlash';
import { nxtPhoneSlash } from './nxtPhoneSlash';
import { nxtPhoneInbound } from './nxtPhoneInbound';
import { nxtPhoneOutbound } from './nxtPhoneOutbound';
import { nxtCallTransfer } from './nxtCallTransfer';
import { nxtCallTransferSolid } from './nxtCallTransferSolid';
import { nxtChime } from './nxtChime';
import { nxtToggleLargeView } from './nxtToggleLargeView';
import { nxtToggleSmallView } from './nxtToggleSmallView';
import { nxtSoundWaveform } from './nxtSoundWaveform';
import { nxtSpeakerView } from './nxtSpeakerView';
import { nxtMerge } from './nxtMerge';
import { nxtDevices } from './nxtDevices';
import { nxtNoteWithCheckmark } from './nxtNoteWithCheckmark';
import { nxtDND } from './nxtDND';
import { nxtSelectPhone } from './nxtSelectPhone';
import { nxtOffline } from './nxtOffline';
import { nxtFavoriteStar } from './nxtFavoriteStar';

const customIcons = {
  callTransfer: nxtCallTransfer,
  callTransferSolid: nxtCallTransferSolid,
  chime: nxtChime,
  devices: nxtDevices,
  dialer: nxtDialer,
  dnd: nxtDND,
  headsetSlash: nxtHeadsetSlash,
  inboundCall: nxtPhoneInbound,
  merge: nxtMerge,
  missedCall: nxtPhoneSlash,
  noteWithCheckmark: nxtNoteWithCheckmark,
  favoriteStar: nxtFavoriteStar,
  offline: nxtOffline,
  outboundCall: nxtPhoneOutbound,
  present: nxtPresent,
  selectphone: nxtSelectPhone,
  soundWaveform: nxtSoundWaveform,
  speakerView: nxtSpeakerView,
  toggleLargeView: nxtToggleLargeView,
  toggleSmallView: nxtToggleSmallView,
} as const;

export { customIcons };
